import React, { useEffect, useState } from "react";
import { FaArrowLeft, FaUpload } from "react-icons/fa";
import Footer from "../../../Components/Footer";
import Navbar from "../../../Components/Navbar";
import { apiPostFormData, Get_Api } from "../../../API/Api_Url";
import { toast } from "react-toastify";
import ConstructionRequirement from "./ConstructionRequirement";
import ServiceRequirement from "./ServiceRequirement";

const AddRequirement = () => {

    const [selecttype, setselecttype] = useState('Construction Requirement');

    const selecttoggle = (type) => {
        setselecttype(type);
    };

    return (
        <>
            <Navbar />
            <div className="w-full max-w-md mx-auto pt-[10%]">
                <h3 className="text-xl font-medium text-gray-700 mb-8 text-center">
                    Select Requirement Type
                </h3>
                <div className="flex gap-4">
                    {["Construction Requirement", "Service Requirement"].map((type) => (
                        <button
                            key={type}
                            onClick={() => selecttoggle(type)}
                            className={`flex-1 py-3 rounded-full font-medium transition-all duration-300 shadow-lg
                                ${selecttype === type
                                    ? "bg-gradient-to-r from-blue-500 to-red-500 text-white hover:opacity-90"
                                    : "bg-gray-200 text-gray-700 hover:bg-gray-300"
                                }`}
                        >
                            {type}
                        </button>
                    ))}
                </div>
            </div>
            {
                selecttype === 'Construction Requirement' &&
                <ConstructionRequirement />
            }
            {
                selecttype === 'Service Requirement' &&
                <ServiceRequirement />
            }

            <Footer />
        </>
    );
};



export default AddRequirement;
